import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {observer} from 'mobx-react'
import Select from 'react-select/async'
import Cookies from "js-cookie";

const selectStyles = {
    valueContainer: (styles) => {
        styles.paddingLeft = '5px'

        return styles
    },
    indicatorSeparator: (styles) => ({
        display: 'none',
    }),
    option: (styles, {data}) => {
        styles.color = data && data.is_empty
            ? '#aaaaaa'
            : '#000000'

        return styles
    },
    group: (styles) => {
        styles.marginLeft = '10px'

        return styles
    },
    groupHeading: (styles) => {
        styles.marginLeft = '-10px'

        return styles
    },
}

const selectNewStyles = {
    valueContainer: (styles) => {
        styles.paddingLeft = '5px'

        return styles
    },
    control: (styles) => {
        styles.padding = '0.1875em 2.25em 0.1875em 0.375em'
        styles.lineHeight = '1.5em'
        styles.border = '0.125em solid var(--border-color-input)'
        styles.color = 'var(--text-color-input)'
        styles.boxSizing = 'border-box'
        styles.backgroundColor = 'var(--background-color-input)'
        styles.backgroundImage = 'url("data:image/svg+xml,<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 177 94\' fill=\'none\'><path fill=\'%23aab\' d=\'M88.5 94L0.598419 0.25L176.402 0.25L88.5 94Z\'/></svg>")'
        styles.backgroundRepeat = 'no-repeat'
        styles.backgroundPosition = 'right 0.6rem center'
        styles.backgroundSize = '0.75em'
        styles.borderRadius = '0.25em'
        styles.transition = '0.1s'

        return styles
    },
    menu: (styles) => {
        styles.backgroundColor = 'rgb(242 243 246)'
        styles.color = 'var(--text-color-input)'

        return styles
    },indicatorsContainer: (styles) => ({
        display: 'none',
    }),
    indicatorSeparator: (styles) => ({
        display: 'none',
    }),
    option: (styles, {data}) => {
        styles.color = data && data.is_empty
            ? '#aaaaaa'
            : '#000000'

        return styles
    },
    group: (styles) => {
        styles.marginLeft = '10px'

        return styles
    },
    groupHeading: (styles) => {
        styles.marginLeft = '-10px'
        styles.color = 'var(--text-color-input)'
        styles.fontWeight = '700'

        return styles
    },
}

const theme = theme => ({
    ...theme,
    borderRadius: 0,
    colors: {
        ...theme.colors,
        // primary: '#000',
        // neutral0: '#fff',
        neutral10: '#000',
        neutral20: '#000',
    },
    spacing: {
        ...theme.spacing,
        controlHeight: 26,
        menuGutter: 2,
        baseUnit: 1,
    },
})

@observer export default class DependentSearchableSelect extends Component {
    render() {
        const {state: _, ...props} = this.props
        const state = this.getFormState()
        const v2 = Cookies.get('force_set_wa_backend_ui_version') == 2

        return (
            <Select
                defaultOptions={[]}
                styles={v2 ? selectNewStyles : selectStyles}
                theme={theme}
                {...props}
                isDisabled={state.inputs_are_disabled}
            />
        )
    }

    /**
     * @return {ProfileSettingsEditState}
     */
    getFormState = () => {
        return this.props.state
    }
}

DependentSearchableSelect.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.any,
        value: PropTypes.any
    })),
    state: PropTypes.any.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.any,
    className: PropTypes.any,
}

